import { Identity } from '../../models/customer.model';

export enum IdentityActionType {
    INIT_IDENTITY = '(INITIAL) SET_IDENTITY',
    SET_IDENTITY = '(SETTER) SET_IDENTITY',
    SET_IDCARD = '(SETTER) SET_IDCARD',
    SET_PHONENUMBER = '(SETTER) SET_PHONENUMBER',
    SET_UPDATE_CHANEL_IDENTITY_FLAG = '(SETTER) SET_UPDATE_CHANEL_IDENTITY_FLAG'
}


export class IdentityState {
    private payload: Identity;

    constructor(payload: Identity) {
        this.payload = payload;
    }

    setIDCard(idcard: string) {
        this.payload.id_card = idcard
    }

    setPhone(phoneNumber: string) {
        this.payload.phone_number = phoneNumber;
    }

    setUpdateChanelIdentityFlag(flag: boolean) {
        this.payload.update_chanel_identity_flag = flag;
    }

    getValue(): Identity {
        return this.payload
    }
}

export class InitialIdentity {
    readonly type: IdentityActionType.INIT_IDENTITY
    payload: Identity;

    constructor() {
        this.payload = null;
    }
}

export class SetIdentityAction {
    readonly type = IdentityActionType.SET_IDENTITY;
    payload: Identity;

    constructor(payload: Identity) {
        this.payload = payload;
    }
}


export class SetIDCardAction {
    readonly type = IdentityActionType.SET_IDCARD;
    payload: Identity;

    constructor(payload: Identity) {
        this.payload = payload;
    }
}


export class SetPhoneNunmberACtion {
    readonly type = IdentityActionType.SET_PHONENUMBER;
    payload: Identity;

    constructor(payload: Identity) {
        this.payload = payload;
    }
}

export class SetUpdateChanelIdentityFlag {
    readonly type = IdentityActionType.SET_UPDATE_CHANEL_IDENTITY_FLAG;
    payload: Identity;

    constructor(payload: Identity) {
        this.payload = payload;
    }
}

export type IdentityAction = InitialIdentity | SetIdentityAction | SetIDCardAction | SetPhoneNunmberACtion | SetUpdateChanelIdentityFlag;
